import { isEqual } from "lodash";
import React from "react";
import DateField from "../../../components/forms/DateField";
import { usePrivilege } from "../../../components/priviledge/PriviledgeProvider";
import useClients from "../../../hooks/api-calls/useClients";
import useCompanies from "../../../hooks/api-calls/useCompanies";
import useParks from "../../../hooks/api-calls/useParks";
import useWindTurbine from "../../../hooks/api-calls/useWindTurbine";
import { FilterOptions } from "../../../hooks/useFilters";
import CustomSelect from "../../../components/forms/CustomSelect";
import useIssuesStatus from "../../../hooks/api-calls/useIssuesStatus";
import useSpecies from "../../../hooks/api-calls/useSpecies";
import useUsers from "../../../hooks/api-calls/useUsers";
import { PiTrashDuotone } from "react-icons/pi";
import { Button } from "rizzui";
import useCensusStatus from "../../../hooks/api-calls/useCensusStatus";

interface OfcFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const OfcFilters: React.FC<OfcFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    // HOOKS

    const { userCan } = usePrivilege();
    const { getCompaniesList } = useCompanies();
    const { getParksList } = useParks();
    const { getCensusStatusList } = useCensusStatus();
    const { getSpeciesList, getSpeciesListScientific } = useSpecies();

    // RENDER

    return (
        <>

            <DateField
                isClearable
                className="w-full"
                label="Fechas"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "date"}
                dateTypesOptions={[
                    { label: "Fecha de reporte", value: "date" },
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" },
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <CustomSelect
                isSearchable
                id={'park'}
                label="Parque eólico"
                options={ getParksList() }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ park: null });
                        return;
                    }
                    updateFilters({ park: e.value });
                }}
                value={filters.filter_filters?.park
                    ? getParksList().filter((park: any) => filters.filter_filters?.park.includes(park.value))
                    : null
                }
                display={userCan('admin_park', 'park')}

            />

            <CustomSelect
                isSearchable
                id={'species'}
                label="Especie afectada"
                italic
                options={ getSpeciesListScientific() }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ species: null });
                        return;
                    }
                    updateFilters({ species: e.value });
                }}
                value={filters.filter_filters?.species
                    ? getSpeciesListScientific().filter((species: any) => filters.filter_filters?.species.includes(species.value))
                    : null
                }
                display={userCan('admin_species', 'species')}
            />

            <CustomSelect
                isSearchable
                id={'status'}
                label="Estado del OFC"
                options={ getCensusStatusList() }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ status: null });
                        return;
                    }
                    updateFilters({ status: e.value });
                }}
                value={filters.filter_filters?.status
                    ? getCensusStatusList().filter((status: any) => filters.filter_filters?.status.includes(status.value))
                    : null
                }
            />

            <CustomSelect
                isSearchable
                isClearable
                id={'company'}
                label="Compañia"
                options={ getCompaniesList() }
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ company: null });
                        return;
                    }
                    updateFilters({ company: e.value });
                }}
                value={filters.filter_filters?.company
                    ? getCompaniesList().filter((company: any) => filters.filter_filters?.company.includes(company.value))
                    : null
                }
                display={userCan('list', 'companies')}
            />

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>   
        </>
        
    )


}

export default OfcFilters;